// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__m1RV9","search":"Settings_search__t0YqU","filter":"Settings_filter__20vKa"};